//roles:["Admin","Developers","Support Admin","Support Manager","Sales"],

export const adminRoutes = [
  {
    path: "/",
    name: "Map",
    children: [
      {
        path: "/",
        alias: "/",
        name: "Map",
        meta: {
          title: "Map",
          icon: "mdi-google-maps",
        },
        icon: "mdi-google-maps",
      },
    ],
  },
  {
    path: "/overview",
    alias: "/overview",
    name: "Overview",
    meta: {
      title: "Dashboard",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-home-variant-outline",
    },
  },
  // {
  //   path: "/on-rent",
  //   alias: "/on-rent",
  //   name: "On Rent",
  //   meta: {
  //     title: "On Rent",
  //     roles: ["Admin", "Birch User", "Customer"],
  //     icon: "mdi-excavator",
  //   },
  // },
  {
    path: "/on-rent",
    alias: "/on-rent",
    name: "On Rent Equipment",
    meta: {
      title: "On Rent Equipment",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-excavator",
    },
  },
  {
    path: "/birch-fleet",
    alias: "/birch-fleet",
    name: "Birch Fleet",
    meta: {
      title: "Birch Fleet",
      roles: ["Admin", "Birch User"],
      icon: "mdi-crane",
    },
  },
  {
    path: "/customer-owned-equipment",
    alias: "/customer-owned-equipment",
    name: "Customer Owned Equipment",
    meta: {
      title: "Customer Owned Equipment",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-account-check-outline",
    },
  },
  {
    path: "/contracts",
    alias: "/contracts",
    name: "Contracts",
    meta: {
      title: "Contracts",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-file-table-box-multiple-outline",
    },
  },
  {
    path: "/",
    alias: "/service-maintenance",
    name: "Service & Maintenance",
    meta: {
      title: "Service & Maintenance",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-cube-outline",
    },
    children: [
      {
        path: "/service-template-management",
        alias: "/service-template-management",
        name: "Service Templates",
        meta: {
          title: "Service Templates",
          roles: ["Admin", "Birch User"],
          // icon: "mdi-account-wrench-outline",
          icon: "mdi-file-image-plus-outline",
        },
      },
      {
        path: "/service-template-mapping",
        alias: "/service-template-mapping",
        name: "Add New Service",
        meta: {
          title: "Add New Service",
          roles: ["Admin", "Birch User"],
          // icon: "mdi-map-outline",
          icon: "mdi-wrench-clock",
        },
      },
      // {
      //   path: "/service-maintenance-details",
      //   alias: "/service-maintenance-details",
      //   name: "Service Maintenance & Details",
      //   meta: {
      //     title: "Service Maintenance & Details",
      //     roles: ["Admin", "Birch User", ],
      //     icon: "mdi-wrench-clock",
      //   },
      // },
      {
        path: "/services",
        alias: "/services",
        name: "Services",
        meta: {
          title: "Services",
          roles: ["Admin", "Birch User"],
          icon: "mdi-chart-bar-stacked",
        },
      },
      {
        path: "/completed-services",
        alias: "/completed-services",
        name: "Completed Services",
        meta: {
          title: "Completed Services",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-package-variant-closed-check",
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/reserveAndPlan",
    name: "Reserve & Order",
    meta: {
      title: "Reserve & Order",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-database",
    },
    // component: Layout,
    children: [
      {
        path: "/create-planning-sheet",
        alias: "/create-planning-sheet",
        name: "Create New Project",
        meta: {
          title: "Create New Project",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-folder-plus",
        },
      },
      {
        path: "/view-current-sheets",
        alias: "/view-current-sheets",
        name: "View Current Projects",
        meta: {
          title: "View Current Projects",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-gift-open",
        },
      },
      {
        path: "/view-historical-sheets",
        alias: "/view-historical-sheets",
        name: "View Historical Projects",
        meta: {
          title: "View Historical Projects",
          roles: ["Admin", "Birch User", "Customer"],
          // icon: "mdi-clipboard-text-clock",
          icon: "mdi-history",
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/newAlerts",
    name: "Alerts Management",
    meta: {
      title: "Alerts Management",
      roles: ["Admin", "Birch User"],
      icon: "mdi-bell-ring-outline",
    },
    children: [
      {
        path: "/alert-management/list",
        alias: "/alert-management/list",
        name: "Alerts List",
        meta: {
          title: "Alerts List",
          roles: ["Admin", "Birch User"],
          icon: "mdi-bell",
        },
      },
      {
        path: "/alert-configuration/list",
        alias: "/alert-configuration/list",
        name: "Alert Configuration",
        meta: {
          title: "Alert Configuration",
          roles: ["Admin", "Birch User"],
          icon: "mdi-bell-plus",
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/reports",
    name: "Reports",
    meta: {
      title: "Reports",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-chart-bar-stacked",
    },
    // component: Layout,
    children: [
      {
        path: "/view-all-reports",
        alias: "/view-all-reports",
        name: "View All Reports",
        meta: {
          title: "View All Reports",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-gesture-tap-button",
        },
      },
      {
        path: "/utilization-report",
        alias: "/utilization-report",
        name: "Utilization Report - Detailed",
        meta: {
          title: "Utilization Report - Detailed",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-speedometer-medium",
        },
      },
      {
        path: "/existing-active-alerts-report",
        alias: "/existing-active-alerts-report",
        name: "Existing Active Alerts",
        meta: {
          title: "Existing Active Alerts",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-sticker-check-outline",
        },
      },
      {
        path: "/on-rent-report",
        alias: "/on-rent-report",
        name: "On Rent",
        meta: {
          title: "On Rent",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-checkbox-marked-outline",
        },
      },
      {
        path: "/on-reservation-report",
        alias: "/on-reservation-report",
        name: "On Reservation",
        meta: {
          title: "On Reservation",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-lock-outline",
        },
      },
      {
        path: "/overdue-report",
        alias: "/overdue-report",
        name: "Overdue",
        meta: {
          title: "Overdue",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-clock-outline",
        },
      },
      {
        path: "/scheduled-reports",
        alias: "/scheduled-reports",
        name: "Scheduled",
        meta: {
          title: "Scheduled",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-calendar-clock",
        },
      },
      // {
      //   path: "/equipment-scheduled-for-pick-up-report",
      //   alias: "/equipment-scheduled-for-pick-up-report",
      //   name: "Scheduled for Pickup",
      //   meta: {
      //     title: "Scheduled for Pickup",
      //     roles: ["Admin", "Birch User", "Customer"],
      //     icon: "mdi-airplane-clock",
      //   },
      // },
      {
        path: "/new-operational-report",
        alias: "/new-operational-report",
        name: "New Operational",
        meta: {
          title: "New Operational",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-movie-star-outline",
        },
      },

      {
        path: "/trip-report",
        alias: "/trip-report",
        name: "Trip",
        meta: {
          title: "Trip",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-map-marker-distance",
        },
      },
      {
        path: "/incident-report",
        alias: "/incident-report",
        name: "Incident",
        meta: {
          title: "Incident",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-calendar-multiple",
        },
      },
      {
        path: "/activity-report",
        alias: "/activity-report",
        name: "Activity",
        meta: {
          title: "Activity",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-history",
        },
      },
      {
        path: "/new-utilization-report",
        alias: "/new-utilization-report",
        name: "Utilization",
        meta: {
          title: "Utilization",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-movie",
        },
      },
      {
        path: "/actual-spend-to-date",
        alias: "/actual-spend-to-date",
        name: "Actual Spend To Date",
        meta: {
          title: "Actual Spend To Date",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-currency-inr",
        },
      },
      {
        path: "/off-rent",
        alias: "/off-rent",
        name: "Off Rent",
        meta: {
          title: "Off Rent",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-layers-off",
        },
      },
      {
        path: "/on-rent-with-spend-analysis",
        alias: "/on-rent-with-spend-analysis",
        name: "On Rent With Spend Analysis",
        meta: {
          title: "On Rent With Spend Analysis",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-cash",
        },
      },
      {
        path: "/planned-actual",
        alias: "/planned-actual",
        name: "Planned Vs Actual",
        meta: {
          title: "Planned Vs Actual",
          roles: ["Admin", "Birch User"],
          icon: "mdi-crop",
        },
      },
      {
        path: "/rent-to-date",
        alias: "/rent-to-date",
        name: "Rent To Date And Projected",
        meta: {
          title: "Rent To Date And Projected",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-chart-box",
        },
      },
      {
        path: "/active-maintenance",
        alias: "/active-maintenance",
        name: "Active Maintenance",
        meta: {
          title: "Active Maintenance",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-wrench",
        },
      },
      {
        path: "/historical-maintenance",
        alias: "/historical-maintenance",
        name: "Historical Maintenance",
        meta: {
          title: "Historical Maintenance",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-cog",
        },
      },
      {
        path: "/customer-balance",
        alias: "/customer-balance",
        name: "Customer Balance",
        meta: {
          title: "Customer Balance",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-bank",
        },
      },
      {
        path: "/service-call",
        alias: "/service-call",
        name: "Service Call",
        meta: {
          title: "Service Call",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-tools",
        },
      },

      {
        path: "/items-rented",
        alias: "/items-rented",
        name: "Items Rented",
        meta: {
          title: "Items Rented",
          roles: ["Admin"],
          icon: "mdi-chart-box",
        },
      },
    ],
  },
  // {
  //   path: "/alerts",
  //   alias: "/alerts",
  //   name: "Alerts",
  //   meta: {
  //     title: "Alerts",
  //     roles: ["Admin", "Birch User", "Customer"],
  //     icon: "mdi-alert-circle-check-outline",
  //   },
  // },
  // hiding sms-alerts as per the request
  // {
  //   path: "/sms-alerts",
  //   alias: "/sms-alerts",
  //   name: "SMS Alerts",
  //   meta: {
  //     title: "SMS Alerts",
  //     roles: ["Admin", "Birch User", "Customer"],
  //     icon: "mdi-message-alert",
  //   },
  // },
  // BE-1121: Access Control is its own top-level section. "Access Control" and
  // "Access Control Codes" are stored permission keys -- renaming either hides a
  // screen. They are grantable and revocable for Customers only: the user store
  // discards stored permissions for Admin and Birch User and gives them the
  // hardcoded list each login. The other two child names are not permission
  // keys; they are gated by role and by the customer's access-code entitlement.
  // See TheLayoutDrawer for the derivation.
  {
    path: "/",
    alias: "/access-control",
    name: "Access Control",
    meta: {
      title: "Access Control",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-shield-key-outline",
    },
    children: [
      {
        path: "/access-control/codes",
        alias: "/",
        name: "Access Control Codes",
        meta: {
          title: "Access Codes",
          navLabel: "Access Codes",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-access-point",
        },
      },
      {
        path: "/access-control/operators",
        alias: "/",
        name: "Access Control Operators",
        meta: {
          title: "Operators",
          navLabel: "Operators",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-account-multiple-outline",
        },
      },
      {
        path: "/access-control/jobsites",
        alias: "/",
        name: "Jobsite Access Codes",
        meta: {
          title: "Jobsite Codes",
          navLabel: "Jobsite Codes",
          roles: ["Admin", "Customer"],
          icon: "mdi-map-marker-outline",
        },
      },
      {
        path: "/access-control/setup",
        alias: "/",
        name: "Access Control Setup",
        meta: {
          title: "Setup",
          navLabel: "Setup",
          roles: ["Admin", "Birch User"],
          icon: "mdi-key-outline",
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/settings",
    name: "Settings",
    meta: {
      title: "Settings",
      roles: ["Admin", "Customer", "Birch User"],
      icon: "mdi-cog-outline",
    },
    children: [
      {
        path: "/settings/notifications",
        alias: "/",
        name: "Notification Settings",
        meta: {
          title: "Notification Settings",
          roles: ["Admin", "Birch User"],
          icon: "mdi-email-check-outline",
        },
      },
      {
        path: "/groups-management/list",
        alias: "/",
        name: "Groups",
        meta: {
          title: "Groups",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-cube-outline",
        },
      },
      {
        path: "/product-exclusions",
        alias: "/product-exclusions",
        name: "Product Exclusions",
        meta: {
          title: "Product Exclusions",
          roles: ["Admin", "Birch User"],
          icon: "mdi-delete-variant",
        },
      },
      {
        path: "/product-catalog",
        alias: "/product-catalog",
        name: "Product Catalog",
        meta: {
          title: "Product Catalog",
          roles: ["Admin", "Birch User"],
          icon: "mdi-package-variant",
        },
      },
      {
        path: "/geofences/list",
        alias: "/",
        name: "Geofences",
        meta: {
          title: "Geofences",
          // roles: ["Admin"],
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-map-marker-circle",
        },
      },

      {
        path: "/planning-sheet-mapping",
        alias: "/",
        name: "Planning Sheet Mapping",
        meta: {
          title: "Planning Sheet Mapping",
          roles: ["Admin"],
          icon: "mdi-crop",
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/admin",
    name: "Admin",
    meta: {
      title: "Admin",
      roles: ["Admin"],
      icon: "mdi-shield-crown-outline",
    },
    // component: Layout,
    children: [
      {
        path: "/customers",
        alias: "/",
        name: "Customers",
        meta: {
          title: "Customer",
          roles: ["Admin"],
          icon: "mdi-account-group-outline",
        },
      },
      {
        path: "/user-management/list",
        alias: "/",
        name: "User Management",
        meta: {
          title: "UserManagement",
          roles: ["Admin"],
          icon: "mdi-account-multiple",
        },
      },
      {
        path: "/point-of-contacts/list",
        alias: "/",
        name: "Point Of Contacts List",
        meta: {
          title: "PointOfContactsList",
          roles: ["Admin", "Birch User", "Customer"],

          icon: "mdi-account-multiple-outline",
        },
      },
    ],
  },
  {
    path: "/logout",
    alias: "/logout",
    name: "Logout",
    meta: {
      title: "Logout",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-exit-to-app",
    },
  },
];
export const hasAccess = {
  dashboard: {
    Sales: {
      environment: false,
      customerReports: true,
      internalReports: true,
      reportStats: true,
      reportAbug: true,
      reportRequest: true,
    },
    "Support Manager": {
      customerReports: false,
      internalReports: true,
      ticketStats: true,
      reportStats: false,
      reportAbug: true,
      reportRequest: false,
    },
  },
  viewReport: {
    "Support Admin": {
      updateStatus: false,
      editReport: true,
    },
    Sales: {
      updateStatus: false,
      editReport: true,
    },
  },
  accessNotes: ["Admin", "Developers"],
};
